import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Shield, FileText, Mail, Phone, RussianRubleIcon } from 'lucide-react';
import { BRAND } from '../config/brand';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white mt-10 z-10 relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Main Footer Content */}
                <div className="py-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {/* Brand Section */}
                        <div className="col-span-1 lg:col-span-2">
                            <Link to="/" className="flex items-center space-x-2 mb-4">
                                <div className="w-10 h-10 bg-gradient-to-r from-primary-700 to-primary-500 rounded-lg flex items-center justify-center">
                                    <span className="text-white font-bold text-xl">a</span>
                                </div>
                                <span className="text-2xl font-bold text-white">{BRAND.name}</span>
                            </Link>
                            <p className="text-gray-300 mb-6 max-w-md">
                                {BRAND.claimRu}
                            </p>
                            <div className="flex space-x-4">
                                <a href={`mailto:${BRAND.contactEmail}`} className="text-gray-400 hover:text-white transition-colors" area-label="Email" title={BRAND.contactEmail}>
                                    <Mail className="w-5 h-5" />
                                </a>
                                <a href="tel:+79194989698" className="text-gray-400 hover:text-white transition-colors" area-label="Phone" title="+7 919 498-96-98">
                                    <Phone className="w-5 h-5" />
                                </a>
                                <a href="https://vk.com/artistixru" target="_blank" className="text-gray-400 hover:text-white transition-colors" area-label="VKontakte" title="artistix bei VK">
                                    <img src="/images/vkontakte.svg" alt="VK" className="w-5 h-5" />
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h3 className="text-lg font-semibold mb-4">Навигация</h3>
                            <ul className="space-y-3">
                                <li>
                                    <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                                        Главная
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/search" className="text-gray-300 hover:text-white transition-colors">
                                        Поиск
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/feed" className="text-gray-300 hover:text-white transition-colors">
                                        Лента
                                    </Link>
                                </li>
                                
                            </ul>
                        </div>

                        {/* Legal & Support */}
                        <div>
                            <h3 className="text-lg font-semibold mb-4">Информация</h3>
                            <ul className="space-y-3">
                                <li>
                                    <Link
                                        to="/pages/tarif"
                                        className="text-gray-300 hover:text-white transition-colors flex items-center"
                                    >
                                        <RussianRubleIcon className="w-4 h-4 mr-2" />
                                        Тарифы
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/help"
                                        className="text-gray-300 hover:text-white transition-colors flex items-center"
                                    >
                                        <FileText className="w-4 h-4 mr-2" />
                                        Справка
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/pages/kontakt"
                                        className="text-gray-300 hover:text-white transition-colors flex items-center"
                                    >
                                        <Mail className="w-4 h-4 mr-2" />
                                        Контакт
                                    </Link>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-gray-800 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <div className="flex flex-col md:flex-row items-center space-x-2 mb-4 md:mb-0">
                            <span className="text-gray-400">© 2008 - {currentYear} {BRAND.name}</span>
                            <span className="text-gray-600"></span>
                            <span className="text-gray-400 flex items-center">
                                Сделано с <Heart className="w-4 h-4 mx-1 text-red-500" /> для Вас!
                            </span>
                        </div>

                        <div className="flex items-center space-x-6 text-sm">
                            <Link
                                to="/pages/politika-konfidentsialnosti"
                                className="text-gray-300 hover:text-white transition-colors flex items-center"
                            >
                                <Shield className="w-4 h-4 mr-2" />
                                Политика обработки и конфиденциальности персональных данных
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
